// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".qRcCWvaGyz5ZaRy38WTWRw\\=\\={width:100%}", "",{"version":3,"sources":["webpack://./src/components/pdpV2/ExtendWarrantyPlaceholder/ExtendWarrantyPlaceholder.module.scss"],"names":[],"mappings":"AAGA,4BACE,UAAA","sourcesContent":["\n                @import '~@purple/style-library/sass/base/base';\n              \n.offer {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"offer": "qRcCWvaGyz5ZaRy38WTWRw=="
};
export default ___CSS_LOADER_EXPORT___;
